import React, {useEffect, useState} from "react"
import {useHistory} from "react-router"
import {Link, useParams} from "react-router-dom"
import { useAlert } from 'react-alert'
import {getSubscriptionPrice} from "../../api"
import useApi from "../../useApi"
import Footer2 from "../../components/Footer/Footer2";
import Logo from "../../assets/images/logo@2x.png"
import Crown from "../../assets/images/shape@2x.png"
import InfoIcon from "../../assets/images/svg/ico-info.svg"

export default function MembershipForm() {

    let history = useHistory();
    const {id} = useParams();

    const [annual, setAnnual] = useState(false);
    const [price, setPrice] = useState(0);
    const [priceDescription, setPriceDescription] = useState("");

    const alert = useAlert();
    const [{data: priceData}, getPrice] = useApi({alert});

    useEffect(() => {
        if (id)
            getPrice(getSubscriptionPrice(id))
    }, [id, getPrice]);

    useEffect(() => {
        if (Object.keys(priceData).length) {
            setAnnual(false);
            setPrice(priceData.monthlyPrice);
            setPriceDescription(priceData.monthlyPriceDescription);
        }
    }, [priceData]);

    const updatePrice = isAnnual => {
        setAnnual(isAnnual);
        if (isAnnual) {
            setPrice(priceData.annualPrice);
            setPriceDescription(priceData.annualPriceDescription);
        }
        else {
            setPrice(priceData.monthlyPrice);
            setPriceDescription(priceData.monthlyPriceDescription);
        }
    };

    const joinBasic = _ => {
        history.push(`/apply/membership/basic/${id}`);
    };

    const joinPremium = _ => {
        history.push(`/payment/${id}${annual ? '?annual=true' : ''}`);
    };

    return (
        <>
            <section className="section-plans">
                <div className="shell">
                    <div className="section__outer">
                        <div className="section__logo">
                            <Link to="/" className="logo">
                                <img src={Logo} alt="" width="200" height="20"/>
                            </Link>
                        </div>
                    </div>

                    <div className="section__head">
                        <h2 className="section__title">Choose a plan that's right for you.</h2>

                        <div className="switch">
                            <div className="switch__inner">
                                <form action="#" method="post">
                                    <div className="checkbox">
                                        <input id="check" type="checkbox"
                                               defaultChecked={annual} value={annual}
                                               onChange={(e) => updatePrice(e.target.checked)}/>

                                        <label htmlFor="check">
                                            <span>monthly</span>
                                            <span>yearly</span>
                                        </label>
                                    </div>
                                </form>

                                <p className="switch__text js-plan-text" data-new-text="Pay yearly, save 10%"
                                   data-old-text="">Pay yearly, save 10%</p>
                            </div>
                        </div>
                    </div>

                    <div className="section__body">
                        <div className="plans">
                            <div className="plan">
                                <div className="plan__head">
                                    <h3 className="plan__title">Basic</h3>

                                    <p>Membership with limited benefits</p>
                                </div>

                                <div className="plan__body">
                                    <div className="plan__price">
                                        <div className="plan__price-outter">
                                            <span className="plan__price-inner">$0</span>
                                            <span className="plan__currency"> USD</span>
                                        </div>
                                    </div>

                                    <div className="plan__actions">
                                        <a href="javascript:void(0)" className="btn btn--success"
                                           onClick={() => joinBasic()}>
                                            join now
                                        </a>
                                    </div>

                                    <div className="plan__entry" style={{display: "block"}}>
                                        <h5 className="plan__entry-title">Benefits</h5>

                                        <ul className="list-dots">
                                            <li>
                                                Newsletter announcing opportunities, thought leadership,
                                                learning opportunities, profiling other members, etc.
                                            </li>
                                            <li>
                                                Private Instagram to see what is happening in The Room
                                            </li>
                                            <li>
                                                Psychometric assessment for awareness about your strengths and
                                                weaknesses. This assessment also provides specific recommendations for
                                                your professional development. (normal cost is $200 USD)
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="plan plan--big">
                                <div className="plan__head">
                                    <div className="plan__icon">
                                        <img src={Crown} alt="" width="40" height="28"/>
                                    </div>

                                    <h3 className="plan__title">Premium</h3>

                                    <p>Membership with full benefits</p>
                                </div>

                                <div className="plan__body">
                                    <div className="plan__price">

                                        <div className="plan__price-outter">
                                            <span className="plan__price-inner">${price}</span>
                                            <span className="plan__currency"> USD</span>

                                            <div className="plan__tooltip tooltip js-tooltip">
                                                <img src={InfoIcon} width="24" height="24" alt="Info icon"/>
                                                <div className="tooltip__inner">
                                                    <p>{priceDescription}</p>
                                                    <div className="tooltip__actions">
                                                        <a href="#" className="js-tooltip-close">
                                                            <img src="assets/images/svg/ico-close.svg" width="20"
                                                                 height="20" alt=""/>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {annual ? (<small>per year</small>) : (<small>per month</small>)}
                                    </div>

                                    <div className="plan__actions">
                                        <a href="javascript:void(0)" className="btn btn--success"
                                           onClick={() => joinPremium()}>
                                            join now
                                        </a>
                                    </div>

                                    <div className="plan__entry" style={{display: "block"}}>
                                        <h5 className="plan__entry-title">Benefits &
                                            Perks</h5>

                                        <ul className="list-dots">
                                            <li>
                                                All Basic Benefits
                                            </li>
                                            <li>
                                                Apply for opportunities (jobs, speaking engagements,
                                                conferences, board appointments, events, fellowships, etc.)
                                            </li>
                                            <li>
                                                Personal “Pathfinder” - your human guide who helps you
                                                navigate The Room's powerful global community
                                            </li>
                                            <li>
                                                In-person and digital events around the world where you can
                                                connect with and learn from members (The Room Global Summit,
                                                masterclasses, etc.)
                                            </li>
                                            <li>
                                                Digital membership platform to connect one-on-one with other
                                                members, post opportunities, organize your own events, etc
                                            </li>
                                            <li>
                                                Clubhouses around the world where you can meet in person
                                                with other members: permanent and “pop up”
                                            </li>
                                            <li>
                                                Nomination rights: Ability to nominate up to 5 new members
                                                per year
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            <Footer2/>
        </>
    );
}